import React, { useContext, useEffect } from 'react';
import { IDefaultResponsiveSupport } from '../../../common/interfaces/common.interface';
import {
  Context as GlobalContext,
  GlobalContextType,
} from '../../../context/global.context';

interface ShareProps extends IDefaultResponsiveSupport {}
const Share: React.FC<ShareProps> = () => {
  const context = useContext(GlobalContext) as GlobalContextType;
  useEffect(() => {
    if (context?.setShareModelVisibility) {
      context?.setShareModelVisibility(true)!;
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return null;
};

export default Share;
